
/**
 * Custom component for Christmas Dining default menu sections.
 *
 * @author Jasper Howard <jhoward@peppermillcas.com>
 * @version 1.2.0
 * @copyright  Copyright (C) 2024-2025, Peppermill Inc. All rights reserved. Redistribution and use in source and binary forms, with or without modification, are not permitted.
 *
 *  2024-12-09 (1.0.0) (jhoward)
 *    - Copy from NewYears_defaultSection.vue component to ChristmasDining_defaultSection.vue component.
 *
 *  2025-02-11 (1.1.0) (jhoward)
 *    - Add <menu-schedules> to the <ChristmasDining_defaultSection> component if in admin view.
 *
 *  2025-04-08 (1.2.0) (jhoward)
 *    - Add support for <default-textual-section> in <ChristmasDining_defaultSection>.
 */

import MenuTag from "../menu-tag.vue";
import MenuTagLegend from "../menu-tag-legend.vue";
import MenuContentArea from "../menu-content-area.vue";
import {defineComponent, PropType} from "vue";
import {ALLOWED_ITEM_COMPONENTS, Menu, MenuSection} from "../defs";
import MenuItemGroup from "../menu-item-group.vue";
import MenuVersion from "../menu-version.vue";
import MenuSchedules from "../schedule/MenuSchedules.vue";
import DefaultVisualSection from "./visual/defaultVisualSection.vue";
import DefaultTextualSection from "./textual/defaultTextualSection.vue";

export default defineComponent({
  components: {
    DefaultTextualSection, DefaultVisualSection,
    MenuSchedules,
    MenuVersion,
    MenuItemGroup,
    MenuContentArea,
    MenuTag,
    MenuTagLegend,
  },
  name: "ChristmasDining_defaultSection",
  props: {
    section: {
      type: Object as PropType<MenuSection>,
      required: true
    },
    menu: {
      type: Object as PropType<Menu>,
      required: true
    },
    menuItemComponent: {
      type: String,
      default: 'christmas-food-item',
      validate: (value: string) => '' === value || ALLOWED_ITEM_COMPONENTS.indexOf(value)
    },
  },
})
